// @flow

import React, { useMemo } from 'react'
import styled from 'styled-components'
import QRCodeLib from 'qrcode'
import Colors from 'frontend_core/dist/styles/colors'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'

const QR_SLOT_PX = 68
const QR_PADDING_PX = 2
const QR_BORDER_PX = 1
const QR_SIZE_PX = QR_SLOT_PX - (QR_PADDING_PX + QR_BORDER_PX) * 2
const QR_QUIET_ZONE = 1
const LOGO_RATIO = 0.3

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing.medium}px;
  max-width: 403px;
  margin: 0 auto;
`

const QrSlot = styled.div`
  position: relative;
  box-sizing: border-box;
  width: ${QR_SLOT_PX}px;
  height: ${QR_SLOT_PX}px;
  flex-shrink: 0;
  padding: ${QR_PADDING_PX}px;
  border: ${QR_BORDER_PX}px solid ${Colors.mono.gray30};
`

const QrSvg = styled.svg`
  width: 100%;
  height: 100%;
  display: block;
`

const LogoWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${QR_SIZE_PX * LOGO_RATIO}px;
  height: ${QR_SIZE_PX * LOGO_RATIO}px;
  line-height: 0;
`

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.small_2}px;
`

const Title = styled.p`
  font-weight: 700;
  font-size: ${fontSize.small_3}px;
  line-height: 135%;
  color: ${Colors.mono.gray100};
  margin: 0;
`

const Description = styled.p`
  font-size: ${fontSize.small__25}px;
  line-height: 150%;
  color: ${Colors.mono.gray100};
  margin: 0;
`

const SpmLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 62 62"
    width="100%"
    height="100%"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="61" height="61" rx="9.5" fill="white" />
    <rect x="0.5" y="0.5" width="61" height="61" rx="9.5" stroke="#EAF0EE" />
    <g clipPath="url(#spm-logo-clip)">
      <rect width="44" height="44" transform="translate(9 9)" fill="white" />
      <path
        d="M10.3253 24.125H21.0971C22.0073 24.125 22.7471 24.8647 22.7471 25.775V36.5467C22.7471 37.0362 22.1558 37.281 21.8093 36.9345L9.93484 25.0627C9.58834 24.7162 9.83309 24.125 10.3226 24.125H10.3253Z"
        fill="#00A273"
      />
      <path
        d="M36.5438 37.8751H25.7721C24.8618 37.8751 24.1221 37.1353 24.1221 36.2251V25.4533C24.1221 24.9638 24.7133 24.7191 25.0598 25.0656L36.9316 36.9373C37.2781 37.2838 37.0333 37.8751 36.5438 37.8751Z"
        fill="#00A273"
      />
      <path
        d="M36.2221 39.25H25.7721C24.8608 39.25 24.1221 39.9887 24.1221 40.9V51.35C24.1221 52.2613 24.8608 53 25.7721 53H36.2221C37.1333 53 37.8721 52.2613 37.8721 51.35V40.9C37.8721 39.9887 37.1333 39.25 36.2221 39.25Z"
        fill="#00A273"
      />
      <path
        d="M37.8721 15.875C37.8721 12.078 34.794 9 30.9971 9C27.2001 9 24.1221 12.078 24.1221 15.875C24.1221 19.672 27.2001 22.75 30.9971 22.75C34.794 22.75 37.8721 19.672 37.8721 15.875Z"
        fill="#00A273"
      />
      <path
        d="M9 22.3264C9 22.3264 9 22.3347 9 22.3374C9 22.5629 9.18425 22.7472 9.4125 22.7472H21.0945C22.0048 22.7472 22.7445 22.0074 22.7445 21.0972V9.41519C22.7445 9.18969 22.563 9.00544 22.3348 9.00269C22.332 9.00269 22.3265 9.00269 22.3238 9.00269C15.0638 9.22269 9.22 15.0664 9 22.3264Z"
        fill="#00A273"
      />
      <path
        d="M39.6707 9.00256C39.6707 9.00256 39.6625 9.00256 39.6597 9.00256C39.4342 9.00256 39.25 9.18681 39.25 9.41506V21.0971C39.25 22.0073 39.9898 22.7471 40.9 22.7471H52.582C52.8075 22.7471 52.9917 22.5656 52.9945 22.3373C52.9945 22.3346 52.9945 22.3291 52.9945 22.3263C52.7745 15.0663 46.9307 9.22256 39.6707 9.00256Z"
        fill="#00A273"
      />
      <path
        d="M52.9971 46.125C52.9971 42.328 49.919 39.25 46.1221 39.25C42.3251 39.25 39.2471 42.328 39.2471 46.125C39.2471 49.922 42.3251 53 46.1221 53C49.919 53 52.9971 49.922 52.9971 46.125Z"
        fill="#00A273"
      />
      <path
        d="M22.3238 52.9971C22.3238 52.9971 22.332 52.9971 22.3348 52.9971C22.5603 52.9971 22.7445 52.8128 22.7445 52.5846V40.9026C22.7445 39.9923 22.0048 39.2526 21.0945 39.2526H9.4125C9.187 39.2526 9.00275 39.4341 9 39.6623C9 39.6651 9 39.6706 9 39.6733C9.21725 46.9333 15.0638 52.7771 22.3238 52.9971Z"
        fill="#00A273"
      />
    </g>
    <defs>
      <clipPath id="spm-logo-clip">
        <rect width="44" height="44" fill="white" transform="translate(9 9)" />
      </clipPath>
    </defs>
  </svg>
)

// 中央ロゴで一部が欠けても読めるよう誤り訂正レベルはH
const useQrSvg = value =>
  useMemo(() => {
    if (!value) return null
    try {
      const qr = QRCodeLib.create(value, { errorCorrectionLevel: 'H' })
      const count = qr.modules.size
      const { data } = qr.modules
      const dim = count + QR_QUIET_ZONE * 2
      let path = ''
      for (let row = 0; row < count; row += 1) {
        for (let col = 0; col < count; col += 1) {
          if (data[row * count + col]) {
            path += `M${col + QR_QUIET_ZONE} ${row + QR_QUIET_ZONE}h1v1h-1z`
          }
        }
      }
      return { path, dim }
    } catch (e) {
      return null
    }
  }, [value])

const AppDownloadQrCard = ({ appLinkUrl }) => {
  const qr = useQrSvg(appLinkUrl)

  return (
    <Wrapper>
      <QrSlot>
        {qr && (
          <>
            <QrSvg
              viewBox={`0 0 ${qr.dim} ${qr.dim}`}
              shapeRendering="crispEdges"
            >
              <rect width={qr.dim} height={qr.dim} fill="#FFFFFF" />
              <path d={qr.path} fill="#000000" />
            </QrSvg>
            <LogoWrap>
              <SpmLogo />
            </LogoWrap>
          </>
        )}
      </QrSlot>
      <TextBlock>
        <Title>アプリならログインの手間いらず</Title>
        <Description>
          スマートフォンでQRコードを読み取るとアプリストアが開きますので、ダウンロードしてください。
        </Description>
      </TextBlock>
    </Wrapper>
  )
}

export default AppDownloadQrCard
